import { spaces } from '@99designs/common/core/settings';
import BoxSelect from 'projects/components/BoxSelect';
import { ObservableField, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';
import styled from 'styled-components';

const Box = styled.div`
    padding: ${spaces.halfGutter}px 0;
`;

interface Fields {
    [key: string]: any;
}

interface Props<T, K> {
    form: ObservableForm<T>;
    name: K;
    title: string;
    required?: boolean;
    options: React.ComponentProps<typeof BoxSelect>['options'];
}

function BoxSelectField<T extends Fields, K extends keyof T>({
    form,
    name,
    title,
    required,
    options,
}: Props<T, K>) {
    return (
        <ObservableField
            form={form}
            name={name}
            title={title}
            required={required}
            render={() => (
                <Box>
                    <BoxSelect options={options} {...form.attach(name, true)} />
                </Box>
            )}
        />
    );
}

export default BoxSelectField;
